import {
  RoomView,
  ArtworkView,
  MuseumView,
  Image360View,
} from 'iovisit-museum-theme/components/Views';

export const IoVisitMuseumViews = (config) => {
  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    Room: RoomView,
    Artwork: ArtworkView,
    Museum: MuseumView,
    Image360: Image360View,
  };
};
